/**
 * Ozo pre-orders: dispatch block's same-day cutoff (snippets/fulfillment-dispatch.liquid).
 *
 * On a business day, for a location with a cutoff, Liquid renders the status and delivery texts twice, keyed by the
 * first dispatch day ([data-dispatch-base], ISO date): today and the next business day (shown by default). Only the
 * browser knows the location's local time: before the cutoff there, today's texts show. Texts say "today" /
 * "tomorrow" relative to the render date (data-today), so on any other local date the default stays. Re-checked every
 * minute and when the tab becomes visible, so an open page moves on at the cutoff. Variant changes re-render the element.
 */
if (!customElements.get("fulfillment-dispatch")) {
  class FulfillmentDispatch extends BaseElement {
    connectedCallback() {
      super.connectedCallback();
      if (!this.dataset.timeZone) return;

      this.clock = new Intl.DateTimeFormat("en-CA", {
        timeZone: this.dataset.timeZone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hourCycle: "h23",
      });
      this.update();
      const timer = setInterval(() => this.update(), 60000);
      this.registerCleanup(() => clearInterval(timer));
      this.on(document, "visibilitychange", () => {
        if (document.visibilityState === "visible") this.update();
      });
    }

    update() {
      const now = Object.fromEntries(
        this.clock
          .formatToParts(new Date())
          .map(({ type, value }) => [type, value]),
      );
      const today = `${now.year}-${now.month}-${now.day}`;
      if (today !== this.dataset.today) return;

      const sameDay = `${now.hour}:${now.minute}` < this.dataset.cutoff;
      this.querySelectorAll("[data-dispatch-base]").forEach((text) => {
        text.hidden = (text.dataset.dispatchBase === today) !== sameDay;
      });
    }
  }
  customElements.define("fulfillment-dispatch", FulfillmentDispatch);
}
